import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    height: 25px;
    width: 60px;
    background-color: #111;
    border: 1px solid #999;
`;

const Input = styled.input`
    position: relative;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    color: #fff;
    background-color: transparent;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    border: 0px;
`;

const Icon = styled.div`
    position: absolute;
    height: 23px;
    width: 23px;
    top: 0;
    right: 0;

    &:before {
        color: #999;
        font-size: 14px;
        font-family: 'Material Design Icons';
        content: '\\F0150';
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;

export default ({onChange, value, ...props}) => {
    const [time, setTime] = useState(value || '00:00');
    const className = props.className ?? '';
    const width = props.width ?? null;

    const handleChange = (e) => {
        let val = e.target.value.replace(/[^\d\:]/gi,'');
        let [hour, minute] = val.split(":");
        let hasMinute = Boolean(minute) && minute.length;

        if (hour.length >= 2 && (minute === undefined || minute.length < 2)) {
            hour = hour.substring(0,2);
            minute = hasMinute ? minute : hour.substring(2,4);
            hasMinute = true;
        }

        hour = hour.substring(0,2);
        minute = (minute ?? '').substring(0,2) ?? '';

        let result = hour + (hasMinute ? ':' : '') + minute;
        
        setTime(result);
        if (onChange && typeof onChange === 'function') {
            onChange(result);
        }
    };

    const handleBlur = (e) => {
        let val = e.target.value.replace(/[^\d]/gi,'');

        let hour = '00' + val.substring(val.length-4, val.length-2);
        let minute = '00' + val.substring(val.length-2, val.length);

        hour = hour.substring(hour.length - 2, hour.length);
        minute = minute.substring(minute.length - 2, minute.length);

        if (parseInt(hour) > 23) {
            hour = '00';
        }
        if (parseInt(minute) > 59) {
            minute = '00';
        }

        let result = hour + ":" + minute;
        
        setTime(result);
        if (onChange && typeof onChange === 'function') {
            onChange(result);
        }
    }

    useEffect(() => {setTime(value)}, [value]);

    return <Container className={className} width={width} {...props} >
        <Icon />
        <Input value={time} onChange={handleChange} onBlur={handleBlur} />
    </Container>




}